<!-- 产品特点,箭头加文字描述 -->
<template>
  <div>
    <div v-for="item in dataList" :key="item.title" class="text-line-height-1 desc-box">
      <picture class="indentation">
        <source media="(max-width: 768px)" srcset="@/assets/img/md/desc/desc.png">
        <source media="(min-width: 768px)" srcset="@/assets/img/lg/desc/desc.png">
        <img src="@/assets/img/lg/desc/desc.png" class="pr-2" />
      </picture>
      <span class="font-weight-600 title-sub">{{ item.title }}</span>
      <span class="title-sub color-desc">{{ item.titleDetail }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescList',
  components: {},
  props: {
    dataList: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
    
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {

  },
  mounted() {
  },
}
</script>
<style scoped>
.desc-box img{
  vertical-align: middle;
}
</style>